import React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomFieldControl } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import {
  INCORPORATION_DATE_GUIDELINES,
  INCORPORATION_DATE_VALIDATION_MSG,
  isIncorporationDateValid,
} from 'global/utils/sponsor-validations/sunLife/incorporationDateValidation';
import { QuestionEntity } from '@insurancemenu/imenu-components-lib';
import { InputTextStyled } from './styles';

interface Props {
  effectiveDate: string;
  field?: CustomFieldControl<string>;
}

const IncorporationDate: React.FC<Props> = observer(({ effectiveDate, field }) => {
  if (!field) {
    return null;
  }

  function onChange(e: React.ChangeEvent<HTMLInputElement>): void {
    if (!field) return;

    const updatedValue = e.target.value;
    field.updateValue(updatedValue);
    field.updateValidationStatus(isIncorporationDateValid(updatedValue, effectiveDate));
  }

  return (
    <QuestionEntity label="Incorporation Date" key="incorporationDate">
      <InputTextStyled
        name="incorporationDate"
        htmlType="date"
        value={field.value}
        onChange={onChange}
        validationPassed={field.isFieldValid}
        validationMessage={field.isFieldValid ? '' : INCORPORATION_DATE_VALIDATION_MSG}
        additionalOptions={{
          guidelines: INCORPORATION_DATE_GUIDELINES,
          showGuidelinesByDefault: true,
        }}
      />
    </QuestionEntity>
  );
});

export default IncorporationDate;
